<ng-container
  *ngTemplateOutlet="
    itemTemplate;
    context: {
      waitingForSetUp: app?.iframeAppConfig?.sharedUrl && !state.sharedUrl && !isAppCreator,
      needsSetUp: app?.iframeAppConfig?.sharedUrl && !state.sharedUrl && isAppCreator
    }
  "
>
</ng-container>
<ng-template #itemTemplate let-waitingForSetUp="waitingForSetUp" let-needsSetUp="needsSetUp">
  <app-base-app
    [state]="state"
    [static]="static"
    [itemModel]="ItemModel.IFrame"
    [interactionBarConfig]="{
      showScreenshotButton: false,
      showAvailabilityButton: false,
      showLockButton: true,
      showPrivacyButton: true,
      showRefreshButton: true,
      showDuplicateButton: (isFullscreenAppInCall$ | async) === false,
      showFullScreenButton: true
    }"
    [shouldRunAppOnMobile]="shouldRunAppOnMobile"
    [selected]="selected$ | async"
    [shouldDisableInteractions]="shouldDisableInteractions$ | async"
    [showLoadingIndicator]="
      (showLoadingIndicator$ | async) || (isReloading$ | async) || waitingForSetUp
    "
    [appIcon]="appIcon$ | async"
    [message]="waitingForSetUp ? ('The host is setting up the app' | translate) : undefined"
    (refreshButtonClicked)="reloadIFrame()"
    (interactionsLockChanged)="onInteractionsLockChanges($event)"
    (privacyChanged)="onPrivacyChanged($event)"
    (deleteItem)="onDeleteItem()"
    (duplicateButtonClicked)="handleDuplicate()"
  >
    <div class="shareable-section" *ngIf="needsSetUp">
      <input
        #shareableInput
        class="shareable-input"
        [ngClass]="{
          'shareable-input-error': (shareableValueError$ | async) !== UrlValidationError.NoError
        }"
        matInput
        [placeholder]="shareableURLPlaceholder | translate"
        [(ngModel)]="shareableValue"
        (keydown)="onkeydown($event)"
      />
      <div
        [hidden]="(shareableValueError$ | async) === UrlValidationError.NoError"
        class="shareable-input-invalid"
      >
        <a
          (click)="
            onOpenLink(
              'https://intercom.help/pencil/en/articles/6965956-troubleshooting-issues-with-using-apps-in-pencil-spaces'
            )
          "
        >
          {{ 'Need Help?' | translate }}
        </a>
      </div>
      <button
        mat-flat-button
        color="primary"
        class="shareable-btn"
        [disabled]="shareableValue?.length < 1"
        (click)="validateUrl()"
      >
        <em class="material-icons">send</em>
        <p>{{ 'Share with participants' | translate }}</p>
      </button>
    </div>
    <div #iframeContainer [style.width]="'100%'" [style.height]="'100%'">
      <iframe
        #iframe
        *ngIf="(isReloading$ | async) === false"
        [hidden]="(isReloading$ | async) || waitingForSetUp"
        [id]="'iframe_item_' + state.uid"
        class="iframe"
        title="iframe"
        [src]="appCreatorIframeUrl ?? state.sharedUrl ?? state.url | safeURL"
        allowfullscreen="allowfullscreen"
        allow="autoplay; fullscreen; clipboard-read; clipboard-write"
        [ngStyle]="
          needsSetUp
            ? { 'max-height': 'calc(100% - 56px)', 'min-height': 'calc(100% - 56px)' }
            : { 'max-height': '100%', 'min-height': '100%' }
        "
        (load)="hideLoadingIndicator()"
        appIframeMouseEvents
      >
      </iframe>
    </div>
  </app-base-app>
</ng-template>
